import { StorageSummaryTable } from '@feedyou/schema'
import { isNotEmptyElement } from '@feedyou/utils'

import { Storage, StorageType } from '../features/storages/types'
import { slugify } from './transliterate'
import { VARIABLE_INTERPOLATED_IN_CURLY_BRACKETS_REGEX } from './regex'
import { wrapInCurlyBrackets } from './variable'
import { STORAGE_PERMITTED_SYMBOLS } from '../features/storages/constants'

export const getVariablesInsideCurlyBrackets = (expression: string): string[] => {
  return Array.from(expression.matchAll(VARIABLE_INTERPOLATED_IN_CURLY_BRACKETS_REGEX)).map(
    match => match[1]
  )
}

export const textIncludesInterpolatedVariable = (text: string) => {
  return getVariablesInsideCurlyBrackets(text).length > 0
}

export const isStorageOfType = (type: StorageType) => (storage: Storage) => {
  return storage?.storageType?.includes(type)
}

export const slugifyStorage = (string?: string) =>
  slugify(string, STORAGE_PERMITTED_SYMBOLS.split(''))

export const interpretInputAsStorageExpression = (input: string): boolean => {
  return !input || textIncludesInterpolatedVariable(input) || input?.includes(' ')
}

export const sanitizeStorageExpression = (
  expression: string | undefined | null
): string | undefined | null => {
  if (!expression) {
    return expression
  }

  if (!interpretInputAsStorageExpression(expression)) {
    return slugifyStorage(expression)
  }

  return expression.replaceAll(
    VARIABLE_INTERPOLATED_IN_CURLY_BRACKETS_REGEX, // I <3 PRETTIER
    (segment: string) => wrapInCurlyBrackets(slugifyStorage(segment))
  )
}

export const doesStorageSummaryIncludeQuery = (
  summaryTable: StorageSummaryTable | undefined,
  query: string
) => {
  return !!summaryTable?.rows
    ?.map(row => row?.storage)
    .filter(isNotEmptyElement)
    .some(expression => {
      const storagesWithinCurlyBrackets = getVariablesInsideCurlyBrackets(expression)

      if (!storagesWithinCurlyBrackets.length) {
        return expression === query
      }

      return storagesWithinCurlyBrackets.includes(query)
    })
}
